import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Introduction from "../../../Component/Paragraph/Introduction";
import Dataservice from "../../../Component/Paragraph/Dataservice";
import { Grid } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
}));

const DocumentDetail = () => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <Introduction />
          <Dataservice />
        </Grid>
      </Grid>
    </div>
  );
};

export default DocumentDetail;
